import { Fragment, jsxs } from "react/jsx-runtime";
const composeStartAdornment = (baseStartAdornment, userStartAdornment) => {
  if (!userStartAdornment) return {};
  return {
    startAdornment: /* @__PURE__ */ jsxs(Fragment, { children: [
      userStartAdornment,
      baseStartAdornment
    ] })
  };
};
function getInputProps(params, InputProps, startAdornment) {
  return {
    ...InputProps ?? {},
    ...params.InputProps,
    ...composeStartAdornment(params.InputProps.startAdornment, startAdornment)
  };
}
export {
  getInputProps
};
//# sourceMappingURL=getInputProps.js.map
